export default __webpack_public_path__ + "static/petronas_logo-77c12d88a2a023f4ca5914162b3cb167.png";